import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect, Fragment, useRef } from 'react';
import { DashboardsBackOffice } from "../../../components/backgrounds/DashboardsBackoffice";
import { HttpRequest } from '../../../services/httpRequest';
import { SuccessAlert } from '../../../components/alerts/successAlert';
import { ErrorAlert } from '../../../components/alerts/errorAlert';
import { roleUser } from '../../../utils/roleUser';

export function ImportDisbursements() {
  const navigate = useNavigate();
  const refFile = useRef()
  const [fileExcel, setFileExcel] = useState(null);
  const [email, setEmail] = useState("");
  const [messsageAlert, setMessageAlert] = useState("");
  const [isOpenSuccess, setIsOpenSuccess] = useState();
  const [isOpenError, setIsOpenError] = useState();
  const [viewalert, setViewalert] = useState(false);

  const getInfoRole = async (doc) => {
    try {
        let response = await HttpRequest.getInfoRole(doc);
        return response.message;
    } catch (error) {
        console.log(error);
        return {}
    }
}

  const handleOpenAlert = (type, message, isOpen) => {
    if (type === 'success') {
      setMessageAlert(message);
      setIsOpenSuccess(isOpen);
      setViewalert(true);
    }
    if (type === 'error') {
      setMessageAlert(message);
      setIsOpenError(isOpen);
      setViewalert(true);
    }
  }

  const handleClearStateAlert = () => {

    setViewalert(false);
    setMessageAlert("");
    setIsOpenSuccess(false);
    setIsOpenError(false);

  }

  const handlechange = (e) => {
    const { value } = e.target;
    setEmail(value);
  }

  const handlerChangeFile = (file) => {
    setFileExcel(file)

  }

  const handleSubmit = async(e) => {
    handleClearStateAlert()
    e.preventDefault();
    
    const formData = new FormData();
    formData.append('file', fileExcel);
    formData.append('email', email);
    try {
      let response = await HttpRequest.importDisbursements(formData);
      setFileExcel(null)
      setEmail('')
      refFile.current.value = ""
      handleOpenAlert('success', response?.message?.message, true);
    } catch (error) {
      console.log(error);
      refFile.current.value = ""
      handleOpenAlert('error', error.message, true);

    }
    setTimeout(() => {
      handleClearStateAlert()
    }, 6000);
  }

  useEffect(() => {
    let doc = localStorage.getItem('doc');
        if (typeof doc !== 'string') {
            return navigate('/ingresar');
        } else {
            getInfoRole(doc)
                .then((infoRole) => {
                    if (infoRole?.error === true) return navigate('/ingresar');
                    if ('user' in infoRole) {
                        let user = infoRole.user;

                        if (user?.roleUser === roleUser.admin) {
                            console.log('User authorized...');
                        } else {
                            alert('No esta autorizado para ver esta página.');
                            setTimeout(() => {
                                return navigate('/ingresar');
                            }, 2000);
                        }
                    } else {
                        return navigate('/ingresar');
                    }
                })
                .catch(e => console.log(e))
        }
  }, [])

  return (
    <Fragment>
      {
        viewalert ?
          <>
            <SuccessAlert isOpen={isOpenSuccess} message={messsageAlert}></SuccessAlert>
            <ErrorAlert isOpen={isOpenError} message={messsageAlert}></ErrorAlert>
          </>
          : <></>
      }

      <DashboardsBackOffice
        name={'Admin'}
        balance={0}
        current12={true}
        title={'Cargue de desembolsos'}
        main={
          <>
            <form action="#" method="POST">
              <div className='px-4 mt-3 py-5 bg-white sm:p-6' style={{borderRadius:'5px'}}>
                <div className="grid grid-cols-8 gap-6">
                  <div className="col-span-8 sm:col-span-4">
                    <label
                      htmlFor="fileexcel"
                      className="block text-sm font-medium"
                    >
                      Cargar archivo
                    </label>
                    <div>
                      <input
                        ref={refFile}
                        onChange={(e) => handlerChangeFile(e.target.files[0])}
                        accept="	application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        type="file"
                        name="fileexcel"
                        id="fileexcel"
                        maxlength="40"
                        className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                      />
                    </div>
                    <span
                      className="text-sm"
                      style={{ color: "#fc3e58", fontStyle: "italic" }}
                    >
                      {''}
                    </span>
                  </div>

                </div>
                <div className="col-span-8 sm:col-span-4 mt-4">
                  <label
                    htmlFor="mail"
                    className="block text-sm font-medium"
                  >
                    Correo para notificar
                  </label>
                  <div>
                    <input
                      value={email}
                      onChange={handlechange}
                      type="email"
                      name="mail"
                      id="mail"
                      maxlength="40"
                      className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                    />
                  </div>
                  <span
                    className="text-sm"
                    style={{ color: "#fc3e58", fontStyle: "italic" }}
                  >
                    {''}
                  </span>

                </div>
                <div className="md:w-56 pt-3 mt-3">
                  <button
                    onClick={handleSubmit}
                    type="button"
                    className="w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-sm text-xl font-medium text-white bg-green transition duration-300 hover:bg-greenDark focus:outline-none"
                  >
                    <div className="flex">
                      {'Cargar'}
                      <div className="grid content-center pl-2">{}</div>
                    </div>
                  </button>
                </div>

              </div>
            </form>

          </>
        }
      />

    </Fragment>
  );
}
